module["exports"] = [
  "090-####-####",
  "080-####-####",
  "070-####-####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ja/cell_phone/formats.js
 ** module id = 791
 ** module chunks = 0
 **/